import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFAB } from "@/components/WhatsAppFAB";

export default function Landing() {
    return (
        <div
            data-testid="landing-page"
            className="relative bg-white text-[#0B1B2B] min-h-screen"
        >
            <Header />
            <main>
                <Hero />
                <Services />
                <About />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFAB />
        </div>
    );
}
